import React, {ReactNode} from "react";
import {Icon, InputLabel, TextField} from "peggirkit";
import ButtonAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/ButtonAddOn";
import {MinusIcon, PlusIcon} from "@heroicons/react/16/solid";

type Props = {
    label: ReactNode,
    value: number,
    onChange: (value: number) => void,
    disabled: boolean,
    max?: number, // Optional maximum: the plus button is disabled when reached
};

const PlusMinusNumberField = ({label, value, onChange, disabled, max}: Props) => {
    return (
        <TextField
            containerClassname={"max-w-[150px]"}
            className={"text-center"}
            type={"text"}
            inputMode={"numeric"}
            label={
                <InputLabel>{label}</InputLabel>
            }
            disabled={disabled}
            value={value}
            onChange={e => onChange(e.target.valueAsNumber)}
            leading={ButtonAddOn({
                position: "leading",
                buttonProps: {
                    iconOnly: true,
                    iconBefore: <Icon icon={MinusIcon}/>,
                    disabled,
                    buttonAction: {
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();

                                if (value === 1)
                                    return;

                                onChange(value - 1);
                            }
                        },
                    },
                },
            })}
            trailing={ButtonAddOn({
                position: "trailing",
                buttonProps: {
                    iconOnly: true,
                    iconBefore: <Icon icon={PlusIcon}/>,
                    disabled: disabled || (max !== undefined && value >= max),
                    buttonAction: {
                        as: "button",
                        actionProps: {
                            onClick: e => {
                                e.preventDefault();
                                onChange(value + 1);
                            }
                        },
                    },
                },
            })}
        />
    );
};

export default PlusMinusNumberField;